import React, { Component } from "react";
import { DatePicker, Button, Select, message ,Modal ,Radio } from "antd";
import SelectProvince from '../../common/SelectProvince';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import SearchMulRetrieve from '../../common/SearchMulRetrieve';
import API_URL from "../../../common/url";
import Fetch from "../../../common/Fetch";
import $ from "../../../common/AjaxRequest";
import moment from "moment";

const monthFormat = "YYYY-MM";
const { MonthPicker } = DatePicker;
const { Option } = Select;

class Filter extends Component {
    state = {
        searchParams: {},
        visible:false,
        isDetail:true
    }

    componentDidMount(){
        this.initializeDate();
        this.getDepartmentList();
    }

    getDepartmentList = () => {
        const options = {
            url: API_URL.manhour.queryManHourRecordDepartment,
            data: { isFilter: 1 },
            dataType: 'json',
            doneResult: ( res => {
                this.setState({ departmentList: res.data });
            }),
        };
        $.sendRequest(options);
    }

    search = () => {
        const {
            searchParams,
            searchParams: {
                areaParams,
            },
        } = this.state;
        if(moment(searchParams.endDate).diff(moment(searchParams.date), 'M') > 2){
            message.error('搜索范围不能超出三个月！');
            return;
        }
        this.props.search({ ...searchParams, ...areaParams, areaParams: '', hasCheckedArea: '' });
    };
    
    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        switch (key) {
            case 'enterpriseDepartmentId': {
                const { departmentList = [] } = this.state;
                searchParams[key] = value;
                searchParams.enterpriseDepartmentName = (departmentList.find(i => i.enterpriseDepartmentId == value) || {}).enterpriseDepartmentName;
                searchParams.positionId = undefined;
                this.handleFilterChange(searchParams);
                break;
            }
            case 'leaderUser':
            case 'position':
            case 'user':
                {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                this.handleFilterChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                this.handleFilterChange(searchParams);
                break;
        }
        this.setState({ searchParams });
    };

    handleSearchChange = (value, option, key) => {
        const { searchParams, onChange } = this.props;
        let list = searchParams[key] ? searchParams[key].split(',') : [];
        if (option) {
            list.push(option.value);
        } else {
            list = list.filter(i => i != value);
        }
        searchParams[key] = list.join(',');
        this.handleFilterChange(searchParams);
    }

    exportButton = () => {
        this.setState({visible:true})
    }
    exportReport = () => {
        const { searchParams, isDetail } = this.state;
        this.props.export({...searchParams , isDetail})
        this.setState({visible:false})
        
    }

    initializeDate = () => {
        const { searchParams } = this.state;
        const date = moment().date() < 26 ? moment().add(-1,'M').format(monthFormat):moment().format(monthFormat);
        searchParams.date = date;
        searchParams.endDate = date;
        this.setState({searchParams},() => { this.search() })
    }

    handleRadioChange = (e) =>{
        this.setState({isDetail:e.target.value})
    }

    disabledDate = (current, key) => {
        const { searchParams } = this.state; 
        const currentValue = current.valueOf();
        if ( key == 'date'){
            return current && (currentValue < moment(searchParams.endDate).add(-11, 'M') || currentValue > moment(searchParams.endDate));
        }else {
            return current && ( currentValue < moment(searchParams.date) || currentValue > moment(searchParams.date).add(11, 'M') );
        }
        
    };
    
    render() {
        const { searchParams, departmentList=[], visible ,isDetail } = this.state;
        const { areaName, positionId, status, hasCheckedArea = [] ,enterpriseDepartmentId } = searchParams;
        const departmentOptions = departmentList.map(d => <Option key={d.enterpriseDepartmentId}>{d.enterpriseDepartmentName}</Option>);
        return (
            <div>
                <div className="search-bar" style={{marginBottom:'10px',width:'100%'}}>
                <div className="search-item" >
                    <label className="ui-label" >
                        收入确认时间
                    </label>
                    <MonthPicker
                        format={monthFormat}
                        value={searchParams.date ? moment(searchParams.date) : null}
                        onChange={(date, dateString) => this.handleChange(dateString, "date")}
                        allowClear={false}
                        disabledDate={(current) => this.disabledDate(current, 'date')}
                        style={{ width: 100, verticalAlign: "middle" }}
                    />
                    <label className="ui-label" style={{ marginLeft: '10px', verticalAlign: "middle" }}>
                        至
                    </label>
                    <MonthPicker
                        format={monthFormat}
                        value={searchParams.endDate ? moment(searchParams.endDate) : null}
                        onChange={(date, dateString) => this.handleChange(dateString, "endDate")}
                        allowClear={false}
                        disabledDate={(current) => this.disabledDate(current, 'endDate')}
                        style={{ width: 100, verticalAlign: "middle" }}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">员工</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 160 }}
                        placeholder="输入姓名/工号检索"
                        value={searchParams.userName}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={value => this.handleChange(value, 'user')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">工作城市</label>
                    <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">直线主管</label>
                    <SearchRetrieve
                        keyword='keyWord'
                        style={{ width: 160 }}
                        placeholder="输入工号或姓名检索"
                        url={API_URL.team.queryEmpListByRoleCode}
                        params={{ limit: 20, needPosition:'TRUE', workStatus:'ALL'}}
                        value={searchParams.leaderUserName}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={(value) => this.handleChange(value, 'leaderUser')}
                    />
                </div>
                <div className="search-item">
                        <label className="ui-label">所属部门</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            style={{ width: 160 }}
                            value={enterpriseDepartmentId}
                            onChange={value => this.handleChange(value, 'enterpriseDepartmentId')}
                        >
                            { departmentOptions }
                        </Select>
                    </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">职位</label>
                    <SearchRetrieve
                        keyword='positionName'
                        placeholder="输入职位自动检索"
                        style={{width: 150}}
                        value={searchParams.positionName}
                        params={{limit: 20,enterpriseDepartmentId}}
                        disabled={!enterpriseDepartmentId}
                        url={API_URL.team.queryUserPositionSelect}
                        config={{ id: 'positionId', name: 'positionName' }}
                        onChange={(value) => this.handleChange(value, 'position')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">状态</label>
                    <Select
                        placeholder="请选择"
                        style={{ width: 120 }}
                        value={ searchParams.status }
                        allowClear={true}
                        onChange={(value) => this.handleChange(value, "status")}
                    >
                        <Option key={'WORKING'} value={'WORKING'}>在职</Option>
                        <Option key={'LEFT'} value={'LEFT'}>离职</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    <Button type="primary" onClick={this.exportButton}>导出</Button>
                </div>
            </div>
            <Modal
                title='导出'
                visible={visible}
                className="creat-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="350px"
                onOk={this.exportReport}
                onCancel={()=>{this.setState({visible:false})}}
            >
                <div style={{padding:'0 20px'}}>
                    <div style={{marginBottom:'10px'}}>
                        是否导出收入明细：
                        <Radio.Group onChange={(e) => {this.handleRadioChange(e)}} value={isDetail}>
                            <Radio value={true}>是</Radio>
                            <Radio value={false}>否</Radio>
                        </Radio.Group>
                    </div>
                </div>
            </Modal>
            </div>
            
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/financeManagement/IncomeReport/Filter.js